'use strict';

var assign = require(168);

var BpmnModdle = require(15);

var packages = {
  bpmn: require(31),
  bpmndi: require(32),
  dc: require(33),
  di: require(34)
};

module.exports = function(additionalPackages, options) {
  return new BpmnModdle(assign({}, packages, additionalPackages), options);
};